import queryString from "qs"
import { number, object, string } from "yup"

export { provider as baseURL } from "constants/apiBaseUrls"

export const Schema = object().shape({
	filter: object().shape({
		member_id: string(),
		intake_type: string(),
		provider_id: string(),
	}),
	sort: object().shape({
		scheduled_at: string(),
	}),
	page: object().shape({
		skip: number(),
		limit: number(),
	}),
})

export const url = ({ filter, sort, page }) =>
	`/v1/visits/pending/intakes?${queryString.stringify({ filter, sort, page })}`
